import { Link } from "gatsby";
import { Section, CodeWrapper, Table, UsefulLinksWrapper, UsefulLink } from 'nca-acquiring-theme';
import { cloudHsmSdkConfigFileSnippet, enableAndConfigureSnippet, genRsaKeySnippet, getLabelSnippet, setLabelSnippet, setSecurityProviderSnippet } from "../../../../src/snippets/AwsCloudHSMSnippets";
import * as React from 'react';
export default {
  Link,
  Section,
  CodeWrapper,
  Table,
  UsefulLinksWrapper,
  UsefulLink,
  cloudHsmSdkConfigFileSnippet,
  enableAndConfigureSnippet,
  genRsaKeySnippet,
  getLabelSnippet,
  setLabelSnippet,
  setSecurityProviderSnippet,
  React
};